module.exports = __webpack_public_path__ + "15a79b3b83f24b8e3f1698454340066c.png";